import { RadioButton, RadioButtonChangeEvent } from "primereact/radiobutton";
import { useThemeSwitch } from "../../theme";
import { ThemeName } from "../../theme/constants";

export function ThemeSwitcher() {
  const { switchToTheme, themeSetting } = useThemeSwitch();

  const handleThemeChange = (value: ThemeName) => {
    switchToTheme(value);
  };

  return (
    <fieldset className="flex gap-5" data-testid="theme-switcher">
      <legend className="sr-only">Theme preference</legend>
      <div className="flex items-center gap-2">
        <RadioButton
          inputId="light"
          name="theme"
          value="atlas-light"
          pt={{ input: { "data-testid": "theme-switcher-light" } }}
          onChange={(e: RadioButtonChangeEvent) => handleThemeChange(e.value)}
          checked={themeSetting === "atlas-light"}
        />
        <label htmlFor="light">Light mode</label>
      </div>
      <div className="flex items-center gap-2">
        <RadioButton
          inputId="dark"
          name="theme"
          value="atlas-dark"
          pt={{ input: { "data-testid": "theme-switcher-dark" } }}
          onChange={(e: RadioButtonChangeEvent) => handleThemeChange(e.value)}
          checked={themeSetting === "atlas-dark"}
        />
        <label htmlFor="dark">Dark mode</label>
      </div>
      <div className="flex items-center gap-2">
        <RadioButton
          inputId="system"
          name="theme"
          value="system"
          pt={{ input: { "data-testid": "theme-switcher-system" } }}
          onChange={(e: RadioButtonChangeEvent) => handleThemeChange(e.value)}
          checked={themeSetting === "system"}
        />
        <label htmlFor="system">Automatic</label>
      </div>
    </fieldset>
  );
}
